import React, { useState, useContext } from "react";

import MythPanda from "../../../../../src/assets/MythPanda.png";
import StandingMythPanda from "../../../../../src/assets/StandingMythPanda.png";
import BusinessSuccess from "../../../../../src/assets/BusinessSuccess.png";
import { FaChevronCircleRight } from "react-icons/fa";
import { UserContext } from "../../../../UserContext";
// import {questionRegistry} from "./questionRegistry.js";

const QuestionPopup = ({ question, onSubmit, onNext, onSkip, initialAnswer = "" }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [answer, setAnswer] = useState(initialAnswer);
  const { user } = useContext(UserContext);

  const userName = user?.firstName ? `${user.firstName}` : "";

  /* ✅ Handle Submit Response → show success screen */
  const handleSubmit = () => {
    setShowSuccess(true);
  };

  /* ✅ Handle Skip → send empty string immediately */
  const handleSkip = async () => {
    await onSubmit?.(""); // send empty payload
    onSkip?.(); // close popup from parent
  };

  /* ✅ Handle “Awesome! What’s Next” */
  const handleCloseSuccess = async () => {
    try {
      // send answer or empty string back to parent
      await onSubmit?.(answer || "");
      // wait a moment before closing (for smooth transition)
      setTimeout(() => {
        setShowSuccess(false); // close success popup
        onNext?.();
      }, 150);
    } catch (err) {
      console.error("Error in handleCloseSuccess:", err);
    }
  };

  return (
    <>
      {/* ---------------- FIRST POPUP (Question) ---------------- */}
      {!showSuccess && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-[100] px-4">
          <div className="bg-white rounded-2xl shadow-xl w-full h-auto max-w-[667px] max-h-[490px] overflow-hidden">
            {/* Header */}
            <div className="bg-[#54B0AF] pt-4 text-white flex items-center gap-3">
              <img
                src={MythPanda}
                alt="Character"
                className="w-48 h-24 max-w-[276.72px] max-h-[287.85px]"
              />
              <div className="py-2 -translate-x-8">
                <p className="text-sm text-[#8BDBDA] font-gotham font-medium uppercase opacity-90 tracking-wide">
                  Quick Question
                </p>
                {/* <h2 className="text-lg md:text-2xl font-gotham font-medium text-white">
                  Which myth are you carrying?
                </h2> */}
                <h2 className="text-lg md:text-2xl font-gotham font-medium text-white">
                  {question || "Which myth are you carrying?"}
                </h2>
              </div>
            </div>

            {/* Body */}
            <div className="p-6">
              <textarea
                className="w-full md:h-[240px] border border-[#B0B0B0] rounded-xl p-3 resize-none focus:outline-none focus:ring-2 focus:ring-[#4EC6C1]"
                rows="4"
                placeholder="Type your answer here..."
                value={answer}
                onChange={(e) => setAnswer(e.target.value)}
              ></textarea>

              {/* Footer */}
              <div className="mt-6 flex items-center justify-between">
                <button
                  onClick={handleSkip}
                  className="text-[#B3B3B3] font-medium uppercase text-sm tracking-wide hover:text-gray-600 transition-colors"
                >
                  Skip Question
                </button>
                <button
                  onClick={handleSubmit}
                  className="bg-black text-white text-base font-medium font-gotham px-5 py-2 rounded-[10px] hover:bg-gray-800 transition"
                >
                  Submit Response
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ---------------- SECOND POPUP (Success) ---------------- */}
      {showSuccess && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-[100] px-4">
          <div className="bg-white rounded-2xl shadow-2xl flex w-full max-w-[667px] h-[490px] overflow-hidden relative">
            {/* Left Side */}
            <div className="bg-[#54B0AF] flex items-center justify-center w-[30%] relative">
              <img
                src={StandingMythPanda}
                alt="Success Panda"
                className="max-w-[390px] md:w-[300px] max-h-[404.72px] h-auto md:h-[400px] object-contain absolute translate-x-10"
              />
            </div>

            {/* Right Side */}
            <div className="flex flex-col justify-center items-center w-1/2 p-8 text-center">
              <div className="mb-6">
                <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center">
                  <img
                    src={BusinessSuccess}
                    alt="Success Business"
                    className="max-w-[120px] h-auto object-contain"
                  />
                </div>

                <h3 className="text-xl font-medium leading-relaxed font-gotham text-[#323232]">
                  Nice {userName}! You're now{" "}
                  <span className="text-[#54B0AF] font-medium">One step</span>{" "}
                  closer to your goal.
                </h3>
              </div>

              {/* ✅ Fixed button */}
              <button
                className="bg-black text-white px-6 py-2.5 font-gotham text-base rounded-lg font-medium hover:bg-gray-800 transition-colors inline-flex items-center gap-2"
                onClick={handleCloseSuccess}
              >
                Awesome! What's Next
                <FaChevronCircleRight size={16} />
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default QuestionPopup;